module.exports = __webpack_public_path__ + "static/media/gear-icon.d8ed7e0c.svg";